import styled from 'styled-components/macro';

// import background image
import portfolioFinancingBackground from '../../../images/portfolio-financing-background.jpg';

const PortfolioFinancingWrapper = styled.section`
  background-image: url(${portfolioFinancingBackground});
  background-size: cover;

  padding: 0 0 50px 0;
`;

export default PortfolioFinancingWrapper;
